<template>
  <div class="logo">
    <a href="https://kanalk.ch/" target="_blank">
      <img class="d-none d-lg-block" :src="require('@/assets/img/NEW_Kanal_K_Logo_schwarz_mit_Claim.png')"/>
      <img class="d-block d-lg-none icon" :src="require('@/assets/img/NEW_Kanal_K_Logo_Web_RGB_schwarz_ICON.png')"/>
    </a>
  </div>
</template>

<script>
export default {
  name: "PartLogo",
  props: {
    containerClass: String,
    logoFile: String,
  }
}
</script>

<style scoped>
header .logo {
  left: 0;
  z-index: 11;
}

header .logo img.icon {
  width: 90px;
}

header .logo img {
  width: 160px;
}

header .menu-social > ul > li > a:hover {
  color: var(--color-selected);
}

@media (max-width: 992px) {
  header .logo {
    position: relative;
    order: 1;
    margin-left: 0;
  }

}

</style>